import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const exKey = (name) => (name || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const embedUrl = (url) => {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?rel=0&playsinline=1`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
};

export const AfVideoPlayer = ({ video, name, onClose }) => {
  const src = video?.source === "upload" ? `${process.env.REACT_APP_BACKEND_URL}/api/exercise-videos/${video.id}/stream` : video?.url;
  const embed = video?.source === "link" ? embedUrl(video.url || "") : null;
  return (
    <Dialog open={!!video} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-lg bg-slate-950 border-slate-800 text-white p-3 sm:p-4" data-testid="af-video-dialog">
        <DialogHeader><DialogTitle className="text-white text-base">{name} · Vídeo American Fit</DialogTitle></DialogHeader>
        <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
          {video && (embed
            ? <iframe src={embed} title={name} className="absolute inset-0 w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen data-testid="af-video-iframe"/>
            : <video src={src} controls playsInline autoPlay className="absolute inset-0 w-full h-full object-contain" data-testid="af-video-player"/>)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
